define('app/collections/travel_plane_collection',['app/setup','app/models/travel_plane_card'], function(takhfifan, planeCard) {

  takhfifan.TravelPlaneCollection = Backbone.Collection.extend({
    model : takhfifan.PlaneCard,
    url: '/api/airline/search',

    parse : function(response, options) {
      if (options.xhr.status == 204) {
        return [];
      }
      var models = [],
        airLines = {},
        flightTypes = {},
        hours = {},
        hoursList = ['تا ۶','۶ تا ۱۲','۱۲ تا ۱۸','۱۸ تا ۲۴'];

      function _filters(model) {
        if (!_.has(airLines, model['AirlineID'])) {
          airLines[model['AirlineID']] = {
            name: model['airlineP'],
            info: model['totalPrice']
          };
        } else {
          airLines[model['AirlineID']].minPrice = _.min(airLines[model['AirlineID']].minPrice, model['totalPrice']);
        }

        if (!_.has(flightTypes, model['bTypeE'])) {
          flightTypes[model['bTypeE']] = {
            name: model['bTypeP']
          }
        }

        var dateArray = model.date.split('-'),
          timeArray = model.departure.split(":");

        model.tmpDepTime = new Date(Date.UTC(dateArray[0],dateArray[1],dateArray[2],timeArray[0],timeArray[1]));
        var depHour = parseInt(timeArray[0], 10);
        if(depHour<6){
          model.tmpDepHour = 0;
        }else if(depHour<12){
          model.tmpDepHour = 1;
        }else if(depHour<18){
          model.tmpDepHour = 2;
        }else{
          model.tmpDepHour = 3;
        }

        if (!_.has(hours, model.tmpDepHour)) {
          hours[model.tmpDepHour] = {
            name: hoursList[model.tmpDepHour]
          }
        }

      }

      _.each(response.departure, function (departureItem) {
        if(departureItem.airline && departureItem.airlineP && departureItem.AirlineID){
          _filters(departureItem);

          if (response.return) {
            _.each(response.return, function (returnItem) {
              _filters(returnItem);
              models.push({
                depTime: departureItem.tmpDepTime,
                totalPrice: parseInt(departureItem.disTotalPrice,10)+parseInt(returnItem.disTotalPrice,10),
                departure: departureItem,
                returnData: returnItem
              });
            });
          } else {
            models.push({
              depTime: departureItem.tmpDepTime,
              totalPrice: parseInt(departureItem.disTotalPrice,10),
              departure: departureItem
            })
          }
        }
      });

      this.filters = [
        {
          type: 'bTypeE',
          name: 'نوع',
          values:  flightTypes
        },
        {
          type: 'AirlineID',
          name: 'ایرلاین',
          values:  airLines
        },
        {
          type: 'tmpDepHour',
          name: 'ساعت',
          values:  hours
        }
      ];

      return models;
    }

  });

});

